"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Compass_exports = {};
__export(Compass_exports, {
  default: () => Compass_default
});
module.exports = __toCommonJS(Compass_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M13.0586 6.89062L8.625 8.375L7.14062 12.8086C7.08854 12.9779 7.10156 13.1406 7.17969 13.2969C7.25781 13.4531 7.375 13.5573 7.53125 13.6094C7.59635 13.6354 7.66146 13.6484 7.72656 13.6484C7.80469 13.6484 7.8763 13.6354 7.94141 13.6094L12.082 12.2227C12.1732 12.1966 12.2513 12.151 12.3164 12.0859C12.3945 12.0078 12.4466 11.9232 12.4727 11.832L13.8594 7.69141C13.9115 7.52214 13.8984 7.35938 13.8203 7.20312C13.7422 7.04688 13.625 6.94271 13.4688 6.89062C13.4036 6.86458 13.332 6.85156 13.2539 6.85156C13.1888 6.85156 13.1237 6.86458 13.0586 6.89062ZM10.5 11.1875C10.2526 11.1875 10.0312 11.1029 9.83594 10.9336C9.65365 10.7513 9.5625 10.5365 9.5625 10.2891C9.5625 10.276 9.5625 10.2695 9.5625 10.2695C9.5625 10.2565 9.5625 10.25 9.5625 10.25C9.5625 9.98958 9.65365 9.76823 9.83594 9.58594C10.0182 9.40365 10.2396 9.3125 10.5 9.3125C10.7604 9.3125 10.9818 9.40365 11.1641 9.58594C11.3464 9.76823 11.4375 9.98958 11.4375 10.25C11.4375 10.5104 11.3464 10.7318 11.1641 10.9141C10.9818 11.0964 10.7604 11.1875 10.5 11.1875ZM10.5 2.75C9.45833 2.75 8.48828 2.94531 7.58984 3.33594C6.67839 3.72656 5.8776 4.26693 5.1875 4.95703C4.51042 5.63411 3.97656 6.42839 3.58594 7.33984C3.19531 8.23828 3 9.20833 3 10.25C3 11.2917 3.19531 12.2617 3.58594 13.1602C3.97656 14.0716 4.51042 14.8724 5.1875 15.5625C5.8776 16.2396 6.67839 16.7734 7.58984 17.1641C8.48828 17.5547 9.45833 17.75 10.5 17.75C11.5417 17.75 12.5117 17.5547 13.4102 17.1641C14.3216 16.7734 15.1159 16.2396 15.793 15.5625C16.4831 14.8724 17.0234 14.0716 17.4141 13.1602C17.8047 12.2617 18 11.2917 18 10.25C18 9.20833 17.8047 8.23828 17.4141 7.33984C17.0234 6.42839 16.4831 5.63411 15.793 4.95703C15.1159 4.26693 14.3216 3.72656 13.4102 3.33594C12.5117 2.94531 11.5417 2.75 10.5 2.75ZM10.5 16.0898C9.69271 16.0898 8.9375 15.9336 8.23438 15.6211C7.51823 15.3216 6.89323 14.9115 6.35938 14.3906C5.83854 13.8568 5.42839 13.2318 5.12891 12.5156C4.81641 11.8125 4.66016 11.0573 4.66016 10.25C4.66016 9.44271 4.81641 8.6875 5.12891 7.98438C5.42839 7.26823 5.83854 6.64974 6.35938 6.12891C6.89323 5.59505 7.51823 5.17839 8.23438 4.87891C8.9375 4.56641 9.69271 4.41016 10.5 4.41016C11.3073 4.41016 12.0625 4.56641 12.7656 4.87891C13.4818 5.17839 14.1003 5.59505 14.6211 6.12891C15.1549 6.64974 15.5716 7.26823 15.8711 7.98438C16.1836 8.6875 16.3398 9.44271 16.3398 10.25C16.3398 11.0573 16.1836 11.8125 15.8711 12.5156C15.5716 13.2318 15.1549 13.8568 14.6211 14.3906C14.1003 14.9115 13.4818 15.3216 12.7656 15.6211C12.0625 15.9336 11.3073 16.0898 10.5 16.0898Z",
      fill: "currentColor"
    }
  )
);
const SvgCompass = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var Compass_default = SvgCompass;
